<script>
    import { onMount } from "svelte";
    import wrappedFetch from "../../wrappedFetch.js";
    import Card from "../components/card.svelte";
    import { multiselectAction } from "../../components/multiselect-action.js";
    import Spinner from "../components/spinner.svelte";

    export let SKUs = [];
    export let ServicePlans = [];
    export let errMsg = '';
    export let licensesConfig;
    export let syncPupils = false;
    export let syncStaff = true;

    let staffSkuId = "";
    let studentSkuId = "";
    let selectElemStaff;
    let selectElemStudents;
    let enabledSPsStaff = [];
    let enabledSPsStudents = [];
    let dataLoaded = false;

    export const ValidateLicenses = () => {

        if (SKUs && SKUs.length > 0)
        {

            if (syncPupils && !studentSkuId)
            {
                errMsg = 'Please select at least one license for pupils.'
                return false;
            }

            if (syncStaff && !staffSkuId)
            {
                errMsg = 'Please select at least one license for staff.'
                return false;
            }

            if (syncStaff && (!jQuery(selectElemStaff).val() || jQuery(selectElemStaff).val() == ""))
            {
                errMsg = 'Please select at least one feature/application for staff.'
                return false;
            }
            if (syncPupils && (!jQuery(selectElemStudents).val() || jQuery(selectElemStudents).val() == ""))
            {
                errMsg = 'Please select at least one feature/application for pupils.'
                return false;
            }

            if (errMsg == '')
                return true;
        }
    }
    
    export const Save = async () => {

        enabledSPsStaff = jQuery(selectElemStaff).val();
        enabledSPsStudents = jQuery(selectElemStudents).val();

        var disabledIdsStaff = servicePlansStaff
                                .filter((sp) => 
                                    !enabledSPsStaff.some((en) => en === sp.servicePlanId)
                                ).map((item) => { 
                                    return item["servicePlanId"]; 
                                });

        var disabledIdsStudents = servicePlansStudents
                                    .filter((sp) =>
                                        !enabledSPsStudents.some((en) => en === sp.servicePlanId)
                                    ).map((item) => {
                                        return item["servicePlanId"];
                                    });

        var disabledPlans = {
            StaffSKUId: syncStaff && (staffSkuId || staffSkuId != '') ? SKUs.find(x => x.id == staffSkuId).skuId : '',
            StudentsSKUId: syncPupils && (studentSkuId || studentSkuId != '') ? SKUs.find(x => x.id == studentSkuId).skuId : '',
            DisabledStudentSPs: disabledIdsStudents,
            DisabledStaffSPs: disabledIdsStaff,
        };

        await wrappedFetch("/api/cloudConfig/SaveLicensePlans", {
            method: "post",
            body: JSON.stringify(disabledPlans),
            headers: {
                "Content-Type": "application/json",
            },
        });
    
        licensesConfig.disabledStaffSPs = disabledPlans.DisabledStaffSPs;
        licensesConfig.disabledStudentSPs = disabledPlans.DisabledStudentSPs;
        licensesConfig.staffSKUId = disabledPlans.StaffSKUId;
        licensesConfig.staffSKUName =  licensesConfig.staffSKUId ? SKUs.find(x => x.skuId == licensesConfig.staffSKUId).skuPartNumber : "";
        licensesConfig.studentsSKUId = disabledPlans.StudentsSKUId;
        licensesConfig.studentsSKUName = licensesConfig.studentsSKUId ? SKUs.find(s => s.skuId == licensesConfig.studentsSKUId).skuPartNumber : "";
    };

    const GetDisabledPlans = async () => {
        // let resp = await wrappedFetch(`/api/cloudConfig/GetDisabledPlans`, {
        //     method: "post",
        // });
        // var result = await resp.json();        
        dataLoaded = true;
        
        if(syncStaff)
        {
            if (licensesConfig.staffSKUId != null && licensesConfig.staffSKUId != "")
            {
                staffSkuId = SKUs.find(x => x.skuId == licensesConfig.staffSKUId).id;
            
                servicePlansStaff = ServicePlans.filter( x => x.sku_Id == staffSkuId && x.friendlyName != null);

                enabledSPsStaff = servicePlansStaff
                                    .filter((sp) => 
                                        !licensesConfig.disabledStaffSPs.some((dis) => dis === sp.servicePlanId)
                                    ).map((item) => { 
                                        return item["servicePlanId"]; 
                                    });                
            }
        }

        if(syncPupils)
        {
            if (licensesConfig.studentsSKUId != null && licensesConfig.studentsSKUId != "")
            {
                studentSkuId = SKUs.find(x => x.skuId == licensesConfig.studentsSKUId).id;

                servicePlansStudents = ServicePlans.filter( x => x.sku_Id === studentSkuId && x.friendlyName != null);
            
                enabledSPsStudents = await servicePlansStudents
                                        .filter((sp) =>
                                            !licensesConfig.disabledStudentSPs.some((dis) => dis === sp.servicePlanId)
                                        ).map((item) => {
                                            return item["servicePlanId"];
                                        });
            
            }
        }

        setTimeout(()=>{
            if(syncPupils)
                servicePlansStudents.forEach((item, i ) => {
                        if (enabledSPsStudents.some( (en) => en == item.servicePlanId)){
                            jQuery(selectElemStudents).multiselect('select', item.servicePlanId, true);  
                        }
                    });
            
            if(syncStaff)
                servicePlansStaff.forEach((item, i ) => {
                        if (enabledSPsStaff.some( (en) => en == item.servicePlanId)){
                            jQuery(selectElemStaff).multiselect('select', item.servicePlanId, true);  
                        }
                    });
        }, 500);

    }

    $: servicePlansStaff = ServicePlans.filter( x => x.sku_Id == staffSkuId && x.friendlyName != null);
    $: servicePlansStudents = ServicePlans.filter( x => x.sku_Id == studentSkuId && x.friendlyName != null);
    
    onMount(async () => {
        GetDisabledPlans();
    });

</script>
<style>
    .disabled{
        pointer-events: none;
        color: grey !important;
    }
    .form-check-label{
        color: #495057;
    }

</style>
<Card>
    <div slot="header">
        <h3>Microsoft licenses</h3>
    </div>
    
    <div slot="body">
    {#if SKUs.length > 0}

        {#if dataLoaded == false}
            <Spinner />
        {:else}
        <div class="form-group {!syncPupils ? 'disabled' : ''}">
            <label for="skuStudent" style="display:block;">Which license do you want to assign to new pupil accounts? </label>
            {#each SKUs as o }
                <div id="skuStudent" class="form-check form-check-inline">
                    <input
                        class="form-check-input {!syncPupils ? 'disabled' : ''}"
                        type="radio"
                        value={o.id}
                        bind:group={studentSkuId}
                    />
                    <p class="form-check-label {!syncPupils ? 'disabled' : ''}">{o.skuPartNumber}</p>
                </div>
            {/each}
        </div>

        <div class="form-group">
            
            {#if servicePlansStudents && servicePlansStudents.length > 0}
            <label for="studentPlan" style="display:block;">What service plans do you want to enable for new pupil accounts?</label>
                <select
                    id="studentPlan"
                    multiple="multiple"
                    bind:this={selectElemStudents}
                    use:multiselectAction={{
                        buttonWidth: '50%', 
                        maxHeight: 500, 
                        numberDisplayed : 2, 
                        includeSelectAllOption: true,
                        enableFiltering: true,
                        includeFilterClearBtn: true,
                        enableCaseInsensitiveFiltering: true,
                        templates: {
                            button: '<button type="button" class="multiselect dropdown-toggle" data-toggle="dropdown" style="text-align: left; border: 1px solid lightgrey; color: #495057;"><span class="multiselect-selected-text"></span></button>'
                        } 
                    }}>

                    {#each servicePlansStudents as item}
                        <option value={item["servicePlanId"]}>
                            {item["friendlyName"]}
                        </option>
                    {/each}

                </select>
            {/if}

        </div>

        <div class="form-group {!syncStaff ? 'disabled' : ''}">
            <label for="skuStaff" style="display:block;">Which license do you want to assign to new staff accounts?</label>
            {#each SKUs as o }
                <div id="skuStaff" class="form-check form-check-inline">
                    <input
                        class="form-check-input {!syncStaff ? 'disabled' : ''}"
                        type="radio"
                        value={o.id}
                        bind:group={staffSkuId}
                    />
                    <p class="form-check-label {!syncStaff ? 'disabled' : ''}">{o.skuPartNumber}</p>
                </div>
            {/each}
        </div>

        <div class="form-group">
            {#if servicePlansStaff && servicePlansStaff.length > 0}
                <label for="staffPlan" style="display:block;">What service plans do you want to enable for new staff accounts?</label>
                <select
                    id="staffPlan"
                    multiple="multiple"
                    bind:this={selectElemStaff}
                    use:multiselectAction={{
                        buttonWidth: '50%', 
                        maxHeight: 500, 
                        numberDisplayed : 2, 
                        buttonTextAlignment: 'left',
                        includeSelectAllOption: true,
                        enableFiltering: true,
                        includeFilterClearBtn: true,
                        enableCaseInsensitiveFiltering: true,
                        templates: {
                            button: '<button type="button" class="multiselect dropdown-toggle" data-toggle="dropdown" style="text-align: left; border: 1px solid lightgrey; color: #495057;"><span class="multiselect-selected-text"></span></button>'
                        } 
                    }}>

                    {#each servicePlansStaff as item}
                        <option value={item["servicePlanId"]}>
                            {item["friendlyName"]}
                        </option>
                    {/each}

                </select>
                <!-- <button class="btn" on:click={SaveServicePlans}> Go </button> -->
            {/if}
        </div>
        {/if}
    {:else if dataLoaded && SKUs.length == 0 }
        <h5>No licenses were found for this microsoft tenancy. </h5>
        <p>Set up can not be completed without licenses. Please make sure you have license before continuing. </p>
    {/if}
</div>
</Card>
{#if errMsg != ''}
    <div style="margin-top: 5px;">
        <span style="color:red;">{errMsg}</span>
    </div>
{/if}
